import { adminSessionFrom, useDocumentTitle, useEmailLogin } from '@pidelo/web-core';
import { AuthLayout, Banner, EmailLoginCard } from '@pidelo/web-ui';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { session } from '../app/core.ts';

/** Only paths inside the admin, never another site. */
function safeBack(value: string | null): string {
  return value && value.startsWith('/') && !value.startsWith('//') ? value : '/';
}

export function LoginPage() {
  useDocumentTitle('Entrar · Pídelo Admin');
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const signedIn = session(state => state.session !== null);
  const endedBy = session(state => state.endedBy);
  const flow = useEmailLogin({
    audience: 'ADMIN',
    onSignedIn: result => {
      session.getState().signIn(adminSessionFrom(result));
      navigate(safeBack(params.get('back')), { replace: true });
    },
  });

  if (signedIn) return <Navigate to={safeBack(params.get('back'))} replace />;

  return (
    <AuthLayout footer="Solo para el equipo de Pídelo. Las cuentas y los permisos los da quien maneja el equipo.">
      <EmailLoginCard
        flow={flow}
        title="Entra al admin"
        notice={endedBy === 'expired' ? <Banner tone="warn">Tu sesión venció. Entra de nuevo.</Banner> : null}
      />
    </AuthLayout>
  );
}
